var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._v("\n  This is the Billing page\n")])}
var staticRenderFns = []

export { render, staticRenderFns }